import { FirebaseDocRefType } from 'firebase/index'
import { useEffect, useState } from 'react'

const useQueryStripeAccountId = (shopRef?: FirebaseDocRefType): string => {
  const [stripeAccountId, setStripeAccountId] = useState<string>('')
  useEffect(() => {
    if (!shopRef) return
    shopRef.get().then((snapshot) => {
      const data = snapshot.data()
      if (!data || !('stripe_account_id' in data)) return
      setStripeAccountId(data.stripe_account_id)
    })
  }, [shopRef])
  return stripeAccountId
}

export default useQueryStripeAccountId
